import { LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'
import { Stack } from '@mui/material'
import { Headline } from 'ComponentLibrary/src/piazza/text/Headline/Headline'
import { useTranslation } from 'react-i18next'

export function AssetListLoadingPage() {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })

    return (
        <PageGridContainer withBottomSpace withTopSpace withFooter>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Headline title={tCommon('assets')} variant="headline1" />
                    <Stack direction="row" gap={tokens.SizingSpacing150} alignItems="center">
                        <LoadingSkeleton variant="rounded" height="32px" width="77px" />
                        <LoadingSkeleton variant="rounded" height="32px" width="150px" />
                    </Stack>
                </Stack>
            </PageGridItem>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <LoadingSkeleton height="32px" width="360px" sx={{ transform: 'translateY(14px)', borderRadius: '16px' }} />
            </PageGridItem>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <Stack direction="column" gap={tokens.SizingSpacing150}>
                    <LoadingSkeleton count={3} height="85px" width="100%" sx={{ transform: 'none' }} />
                </Stack>
            </PageGridItem>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <LoadingSkeleton height="32px" width="420px" sx={{ transform: 'translateY(14px)', borderRadius: '16px' }} />
            </PageGridItem>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <Stack direction="column" gap={tokens.SizingSpacing150}>
                    <LoadingSkeleton count={2} height="85px" width="100%" sx={{ transform: 'none' }} />
                </Stack>
            </PageGridItem>
        </PageGridContainer>
    )
}
